<template>
  <div>
    <navbar />
    <section>
    <div class="container-fluid " :class="env=='live'?'container-height':'container-height-staging'">
      <Breadcrumb/>
     <router-view/>
    </div>
    </section>
  </div>  
</template>

<script>
 import Navbar from '@/components/Navbar';
 import Breadcrumb from '@/components/Breadcrumbs';

 export default {
  name: 'layout',
  components: {   
    Navbar, Breadcrumb,  
  },
  data(){
    return{     
      env:process.env.VUE_APP_ENV
    }
  },
}
</script>

<style>
  .container-height {
    margin-top: 4.5rem !important;
  }
   .container-height-staging {
    margin-top: 6.2rem !important;
  }
</style>